import React, { useState, useEffect, useRef } from 'react';
import {
  Box,
  Typography,
  Button,
  TextField,
  InputAdornment,
  IconButton,
  Paper,
  List,
  ListItemButton,
  ListItemText
} from '@mui/material';
import { useNavigate } from "react-router";
import { useSelector } from 'react-redux';
import SearchIcon from '@mui/icons-material/Search';

const MiniHeader = () => {
  const navigate = useNavigate();
  const { isAuthenticated, currentUser } = useSelector((state) => state.auth);

  const [searchValue, setSearchValue] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const searchBoxRef = useRef(null);

  // Close suggestions when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchBoxRef.current && !searchBoxRef.current.contains(event.target)) {
        setSuggestions([]);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // STATIC SEARCH DATA
  const searchPages = [
    { label: "Pledge", path: "/pledge" },
    { label: "Team", path: "/team" },
    { label: "7 Missions", path: "/7missions" },
    { label: "Rewards", path: "/rewards" },
    { label: "Contact", path: "/contact" },
    { label: "Schools Colleges Universities", path: "/Schools-Colleges-Universities" },
    { label: "Organisations Corporates", path: "/Organisations-Corporates" },
    { label: "Events", path: "/Events" },
    { label: "Cities", path: "/Cities" },
    { label: "Networks International Directors", path: "/Networks-International-Directors" },
    { label: "Gifts", path: "/Gifts" },
    { label: "Gifts Login", path: "/Gifts/Login" },
    { label: "Institute Courses", path: "/Institute" },
    { label: "Influencers", path: "/Influencers" },
    { label: "Welfare Fund", path: "/Welfare-Fund" },
    { label: "Cafee", path: "/Cafee" },
    { label: "Voices", path: "/Voices" },
    { label: "Arts and Publications", path: "/Arts-and-Publications" },
    { label: "Payments", path: "/payments" },
    { label: "Home", path: "/" },
    { label: "Login", path: "/login" },
    { label: "Register", path: "/register" },
    { label: "Dashboard", path: "/dashboard" },
  ];

  // HANDLE INPUT CHANGE
  const handleChange = (e) => {
    const value = e.target.value;
    setSearchValue(value);

    if (!value) {
      setSuggestions([]);
      return;
    }

    const filtered = searchPages.filter(page =>
      page.label.toLowerCase().includes(value.toLowerCase())
    );

    setSuggestions(filtered);
  };

  // CLICK SUGGESTION
  const handleSelect = (path) => {
    navigate(path);
    setSearchValue("");
    setSuggestions([]);
  };

  // ENTER KEY SUPPORT
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && suggestions.length > 0) {
      handleSelect(suggestions[0].path);
    }
  };

  const getUserDisplayName = () => {
    if (!currentUser) return '';
    return currentUser.name || currentUser.username || currentUser.email || '';
  };

  return (
    <Box
      sx={{
        background: 'linear-gradient(to right, #007A6B, #0C5A89)',
        color: 'white',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        px: 2,
        py: 1,
        paddingRight: "34px",
        gap: 2,
        position: "relative"
      }}
    >

      {/* Search Container */}
      <Box ref={searchBoxRef} sx={{ position: "relative" }}>
        <TextField
          variant="outlined"
          size="small"
          placeholder="Search"
          value={searchValue}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          sx={{
            backgroundColor: 'white',
            borderRadius: 1,
            width: { xs: '120px', sm: '200px' },
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton size="small">
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        {/* Dropdown Suggestions */}
        {suggestions.length > 0 && (
          <Paper
            sx={{
              position: "absolute",
              top: "40px",
              width: "100%",
              zIndex: 2000,
              maxHeight: 250,
              overflowY: "auto"
            }}
          >
            <List>
              {suggestions.map((item, index) => (
                <ListItemButton
                  key={index}
                  onClick={() => handleSelect(item.path)}
                >
                  <ListItemText primary={item.label} />
                </ListItemButton>
              ))}
            </List>
          </Paper>
        )}
      </Box>

      {isAuthenticated && currentUser ? (
        <>
          <Typography sx={{ fontSize: 14, display: { xs: 'none', sm: 'block' } }}>
            Welcome, {getUserDisplayName()}
          </Typography>
          <Button onClick={() => navigate('/dashboard')}>
            Dashboard
          </Button>
        </>
      ) : (
        <Button sx={{color: "#fff", fontWeight: "bold"}} onClick={() => navigate('/login')}>
          Login
        </Button>
      )}
    </Box>
  );
};

export default MiniHeader;
